import { apiFetch } from "~/lib/fetchClient";

// Thin wrappers over apiFetch for the voicemail-drop recordings endpoints
// (PR 3 #859). All paths are relative to the /api/v1 prefix that apiFetch
// already applies.

const buildFormData = ({ name, file }) => {
  const formData = new FormData();
  formData.append("name", name);
  // Omit `audio` for rename-only updates; include it to create/replace.
  if (file) {
    formData.append("audio", file);
  }
  return formData;
};

export const voicemailRecordingsApi = {
  // GET /voicemail_recordings -> bare JSON array of recordings
  list: () => apiFetch.get("/voicemail_recordings"),

  // POST /voicemail_recordings (multipart) -> created recording
  create: ({ name, file }) =>
    apiFetch.post("/voicemail_recordings", {
      body: buildFormData({ name, file }),
    }),

  // PATCH /voicemail_recordings/:id (multipart, audio optional) -> recording
  update: (id, { name, file }) =>
    apiFetch.patch(`/voicemail_recordings/${id}`, {
      body: buildFormData({ name, file }),
    }),

  // DELETE /voicemail_recordings/:id -> 204 No Content
  remove: (id) => apiFetch.delete(`/voicemail_recordings/${id}`),

  // PATCH /voicemail_recordings/:id/default -> the now-default recording
  makeDefault: (id) => apiFetch.patch(`/voicemail_recordings/${id}/default`),

  // GET /voicemail_recordings/:id/preview -> streams audio bytes inline.
  // Use raw() so the app's auth headers attach, then read the blob and wrap
  // it in an object URL the caller can play and later revoke.
  preview: async (id) => {
    const response = await apiFetch.raw(`/voicemail_recordings/${id}/preview`);
    if (!response.ok) {
      throw new Error(`Preview failed (${response.status})`);
    }
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  },
};
